export default {"src":"/_next/static/media/thank_image.a6c22b9a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};